<script setup lang="ts">
  import { computed } from 'vue';
  import type { ProductVariantResource } from '@storefront/resources';

  interface Props {
    variant: ProductVariantResource,
  }

  const props = defineProps<Props>();
  const files = computed(() => props.variant.files.filter((file) => file.type === 'downloads'));
</script>
<template>
  <section v-if="files.length > 0" class="files">
    <h2>{{ $t('SHOP.COMMON.HEADER.FILES_TO_DOWNLOAD') }}</h2>
    <ul class="files__list">
      <li v-for="file in files">
        <a :href="file.raw || $route('public.media.file.download', { filename: file.filename })" target="_blank">
          <span class="icon">
            <SfIconDownload aria-hidden="true" />
          </span>
          <span class="name">
            {{ file.displayName || file.original || file.filename }}
          </span>
        </a>
      </li>
    </ul>
  </section>
</template>
<style scoped lang="scss">
  .files {
    h2 {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    ul {
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 0.5rem;
      line-height: 1.5rem;
      list-style: none;
      padding: 0;
      margin: 0;

      a {
        display: flex;
        align-items: flex-start;
        line-height: 1rem;
        font-size: 0.875rem;
        gap: 0.5rem;

        svg {
          display: inline-block;
          font-size: 1rem;
        }

        .name {
          word-break: break-all;
        }
      }
    }
  }
</style>
